import { getGridStringOperators } from '@mui/x-data-grid-premium';
import Model from '../models/model';

const model = new Model({
	name: 'Language',
	defaultSort: 'LanguageName',
	disableDelete: true,
	title: 'Language',
	formTitleField: 'LanguageName',
	showGridRefreshBtn: true,
	filter: [{"operator": "$eq", "property": "IsShow", "value": true}],
	columns: [
		{ header: 'UniqueId', field: 'LanguageId', keyColumn: true, width: 120, hidden: true },
		{ header: 'LanguageName', field: 'DisplayValue', width: 120, required: true },
		{ header: 'LanguageCode', field: 'LanguageCode', width: 200, required: true },
		{ header: 'Active', field: 'Active', type: "bool", width: 120, required: true },
		{ header: 'LastUpdateDate', field: 'ModifiedOn', width: 180, type: 'dateTime', isLocal: true, readOnly: true, isNotformfield: true },
		{ header: 'CreatedBy', field: 'CreatedByUserId', width: 180, isNotformfield: true, readOnly: true, filterOperators: getGridStringOperators().filter(op => op.value === 'contains') },
	]
});

export default model.createFormBase();
